import ozkLogo from "../images/insurers/ozk.svg";
import dziLogo from "../images/insurers/dzi.svg";
import armeecLogo from "../images/insurers/armeec.svg";
import levinsLogo from "../images/insurers/levins.svg";
import generaliLogo from "../images/insurers/generali.svg";
import dallboggLogo from "../images/insurers/dallbogg.png";
import bulinsLogo from "../images/insurers/bulins.png";
import euroinsLogo from "../images/insurers/euroins.png";

export interface Insurer {
  /** Официалното наименование, както се изписва в полица. */
  name: string;
  /** Кратко име за тесни колони и мобилен изглед. */
  short: string;
  /** Липсва, когато логото още не е налично - тогава се показва монограм. */
  logo?: string;
}

export const INSURERS: Record<string, Insurer> = {
  ozk: { name: "ЗАД „ОЗК - Застраховане“", short: "ОЗК", logo: ozkLogo },
  dzi: { name: "ЗАД „ДЗИ - Общо застраховане“", short: "ДЗИ", logo: dziLogo },
  dallbogg: { name: "ЗАД „ДаллБогг: Живот и Здраве“", short: "ДаллБогг", logo: dallboggLogo },
  generali: { name: "ЗАД „Дженерали Застраховане“", short: "Дженерали", logo: generaliLogo },
  bulins: { name: "ЗК „Бул Инс“ АД", short: "Бул Инс", logo: bulinsLogo },
  levins: { name: "ЗК „Лев Инс“ АД", short: "Лев Инс", logo: levinsLogo },
  armeec: { name: "ЗАД „Армеец“", short: "Армеец", logo: armeecLogo },
  euroins: { name: "ЗД „Евроинс“ АД", short: "Евроинс", logo: euroinsLogo },
};

export function insurerName(id: string): string {
  return INSURERS[id]?.name ?? id;
}

export function insurerShort(id: string): string {
  return INSURERS[id]?.short ?? id;
}

export function insurerMonogram(id: string): string {
  const short = INSURERS[id]?.short ?? id;
  return short.slice(0, 2).toUpperCase();
}
